import './DealerMap.css';const dealerMap = "_dealerMap_15q6v_1";
const dealerMap__mapWrapper = "_dealerMap__mapWrapper_15q6v_14";
const dealerMap__cardContainer = "_dealerMap__cardContainer_15q6v_48";
const dealerMap__row = "_dealerMap__row_15q6v_60";
const dealerMap__dealerCard = "_dealerMap__dealerCard_15q6v_63";
const dealerMap__dealerLocation = "_dealerMap__dealerLocation_15q6v_66";
const dealerMap__dealerContact = "_dealerMap__dealerContact_15q6v_66";
const dealerMap__dealerCardInfo = "_dealerMap__dealerCardInfo_15q6v_70";
const styles = {
  dealerMap,
  dealerMap__mapWrapper,
  dealerMap__cardContainer,
  dealerMap__row,
  dealerMap__dealerCard,
  dealerMap__dealerLocation,
  dealerMap__dealerContact,
  dealerMap__dealerCardInfo
};
export {
  dealerMap,
  dealerMap__cardContainer,
  dealerMap__dealerCard,
  dealerMap__dealerCardInfo,
  dealerMap__dealerContact,
  dealerMap__dealerLocation,
  dealerMap__mapWrapper,
  dealerMap__row,
  styles as default
};
